import React from 'react';
import { Tabs } from 'antd';
import { ApimPageShell } from '@pages/api-portal/apim-page-shell';
import { useApiManagement } from './use-api-management';
import { GroupsManager } from './groups-manager';
import { EndpointsManager } from './endpoints-manager';
import { API_MANAGEMENT_TABS } from '@pages/api-portal/constants';

/*
 * Admin screen for API Management — API Groups and API Endpoints CRUD, tabbed and
 * deep-linkable via ?tab=.
 */
export function ApiManagementScreen() {
    const { activeTab, setActiveTab } = useApiManagement();

    return (
        <ApimPageShell navSelectedId="api-management" navType="admin">
            <header>
                <h1>
                    <img src="/icons/code.png" alt="" width={28} height={28} />
                    API Management
                </h1>
            </header>
            <Tabs activeKey={activeTab} onChange={setActiveTab}>
                <Tabs.TabPane tab="API Groups" key={API_MANAGEMENT_TABS.groups}>
                    <GroupsManager />
                </Tabs.TabPane>
                <Tabs.TabPane tab="API Endpoints" key={API_MANAGEMENT_TABS.endpoints}>
                    <EndpointsManager />
                </Tabs.TabPane>
            </Tabs>
        </ApimPageShell>
    );
}
